import { Box, Grid, ImageList, ImageListItem, Typography } from "@mui/material";
import InnerHTML from "dangerously-set-html-content";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function ActivitatInfo({ activitat }) {
	return (
		<Grid spacing={5} container mb={5}>
			<Grid item md={5} style={{ position: "relative" }}>
				<Box mt={2}>
					<img
						src={process.env.REACT_APP_STORAGE + activitat?.imatge}
						style={{
							width: "100%",
						}}
						alt={activitat?.nom}
					/>
				</Box>
				{activitat?.galeries?.flatMap((g) => g.imatges ?? []).length > 0 && (
					<ImageList cols={4} gap={4} sx={{ mt: 1 }}>
						{activitat.galeries
							.flatMap((g) => g.imatges ?? [])
							.slice(0, 16)
							.map((item) => (
								<ImageListItem key={item.id}>
									<Zoom>
										<img
											src={process.env.REACT_APP_STORAGE + item.foto}
											alt={item.foto}
											style={{ width: "100%", aspectRatio: "1", objectFit: "cover", display: "block", cursor: "zoom-in" }}
											loading="lazy"
										/>
									</Zoom>
								</ImageListItem>
							))}
					</ImageList>
				)}
			</Grid>
			<Grid item md={7}>
				<Typography variant="body1" mb={8}>
					<InnerHTML html={activitat?.descripcio} />
				</Typography>
				{activitat?.que_fem && (
					<Box>
						<Typography variant="h4" mb={2} color={activitat?.color}>
							Què fem?
						</Typography>
						<Typography variant="body1" mb={8}>
							<div
								dangerouslySetInnerHTML={{
									__html: activitat?.que_fem,
								}}
							/>
						</Typography>
					</Box>
				)}
				{activitat?.activitats_text && (
					<Box>
						<Typography variant="h4" mb={2} color={activitat?.color}>
							Activitats
						</Typography>
						<Typography variant="body1" mb={8}>
							<div
								dangerouslySetInnerHTML={{
									__html: activitat?.activitats_text,
								}}
							/>
						</Typography>
					</Box>
				)}
			</Grid>
		</Grid>
	);
}
